export default __webpack_public_path__ + "ed11452dfdbe0439b8642dd817b69407.svg";